// Google Analytics tracking helper functions

export function trackStoreOpen(store) {
  console.log('📊 GA Event - Store Modal Opened:', {
    store_name: store.fields.Name,
    store_id: store.id,
    store_city: store.fields.City,
    store_state: store.fields.State
  });
  
  if (window.gtag) {
    // Custom event (for your custom dimensions)
    window.gtag('event', 'store_modal_open', {
      'store_name': store.fields.Name,
      'store_id': store.id,
      'store_city': store.fields.City,
      'store_state': store.fields.State,
      'store_address': `${store.fields.City}, ${store.fields.State}`
    });
    
    // Standard GA4 content interaction event
    window.gtag('event', 'select_content', {
      content_type: 'store',
      content_id: store.id,
      items: [{
        item_id: store.id,
        item_name: store.fields.Name,
        item_category: 'Store',
        item_variant: store.fields.State,
        item_brand: 'Good Feels'
      }]
    });
  } else {
    console.warn('⚠️ Google Analytics not available - store_modal_open event not sent');
  }
}

export function trackStoreWebsiteVisit(store, type) {
  console.log('📊 GA Event - Store Website Visit:', {
    store_name: store.fields.Name,
    store_id: store.id,
    visit_type: type
  });
  
  if (window.gtag) {
    window.gtag('event', 'store_website_visit', {
      'store_name': store.fields.Name,
      'store_id': store.id,
      'store_city': store.fields.City,
      'store_state': store.fields.State,
      'visit_type': type
    });
  } else {
    console.warn('⚠️ Google Analytics not available - store_website_visit event not sent');
  }
}

export function trackProductView(product, store) {
  console.log('📊 GA Event - Product View:', {
    product_name: product.name,
    product_id: product.id,
    store_name: store.fields.Name,
    price: product.configs?.[0]?.normalPrice || 0,
    sale_price: product.configs?.[0]?.salePrice || 0
  });
  
  if (window.gtag) {
    // Send custom event (for your custom dimensions)
    window.gtag('event', 'product_view', {
      'product_name': product.name,
      'product_id': product.id,
      'store_name': store.fields.Name,
      'store_id': store.id,
      'price': product.configs?.[0]?.normalPrice || 0,
      'sale_price': product.configs?.[0]?.salePrice || 0
    });
    
    // Also send standard GA4 e-commerce event
    window.gtag('event', 'view_item', {
      currency: 'USD',
      value: product.configs?.[0]?.normalPrice || 0,
      items: [{
        item_id: product.id,
        item_name: product.name,
        price: product.configs?.[0]?.normalPrice || 0,
        discount: product.configs?.[0]?.salePrice ? (product.configs[0].normalPrice - product.configs[0].salePrice) : 0,
        item_brand: 'Good Feels',
        item_category: product.category || '',
        quantity: 1,
        affiliation: store.fields.Name,
        location_id: store.id
      }]
    });
  } else {
    console.warn('⚠️ Google Analytics not available - product_view event not sent');
  }
}

export function trackGetDirections(store) {
  console.log('📊 GA Event - Get Directions:', {
    store_name: store.fields.Name,
    store_id: store.id,
    store_city: store.fields.City
  });
  
  if (window.gtag) {
    window.gtag('event', 'get_directions', {
      'store_name': store.fields.Name,
      'store_id': store.id,
      'store_city': store.fields.City,
      'store_state': store.fields.State
    });
  } else {
    console.warn('⚠️ Google Analytics not available - get_directions event not sent');
  }
}

export function trackProductSearch(searchParams) {
  console.log('📊 GA Event - Product Search:', searchParams);
  
  if (window.gtag) {
    window.gtag('event', 'search', {
      search_term: searchParams.nameFilter || '',
      search_mode: searchParams.searchMode || 'exclusive',
      min_price: searchParams.minPrice || '',
      max_price: searchParams.maxPrice || ''
    });
  } else {
    console.warn('⚠️ Google Analytics not available - product_search event not sent');
  }
} 